<script>
	export let value = {
		visible: true,
		home_page_title: "Home"
	};
</script>

<!-- Navbar component examples are not displayed as it's a configuration component -->
<div style="display: none;">
	Navbar config: visible={value.visible}, home_page_title="{value.home_page_title}"
</div>
